import { AccessoriesSection } from 'components/common/settings-dialog/main-sections/accessories-section';
import { InterfaceSection } from 'components/common/settings-dialog/main-sections/interface.section';
import { MachineSection } from 'components/common/settings-dialog/main-sections/machine.section';
import { UserSection } from 'components/common/settings-dialog/main-sections/user-section';
import {
  MachineSettingsTabKey,
  SettingsSection,
  UserSettingsTabKey,
} from 'enums/settings';

interface IProps {
  active: SettingsSection;
  initialMachineTab?: MachineSettingsTabKey;
  initialUserTab?: UserSettingsTabKey;
  onClose: () => void;
}

export const SectionContent = (props: IProps) => {
  switch (props.active) {
    case SettingsSection.Machine: {
      return (
        <MachineSection
          initialTab={props.initialMachineTab}
          onClose={props.onClose}
        />
      );
    }

    case SettingsSection.Interface: {
      return <InterfaceSection />;
    }

    case SettingsSection.User: {
      return (
        <UserSection
          initialTab={props.initialUserTab}
          onClose={props.onClose}
        />
      );
    }

    case SettingsSection.Accessories: {
      return <AccessoriesSection />;
    }

    default: {
      return null;
    }
  }
};
